import { RefinProvider } from '@/providers/refin';
import { NextRepayment } from './components/NextRepayment';
import { FutureRepayments } from './components/FutureRepayments';
import s from './index.module.scss';

const PaymentsNextPage = () => {
  return (
    <RefinProvider>
      <div className={s.page}>
        <NextRepayment />
        <FutureRepayments />
      </div>
    </RefinProvider>
  );
};

export default PaymentsNextPage;
